<h2 mat-dialog-title>{{isReadOnly ? 'Talep Detayı' : 'Yeni Kayıt'}}</h2>

<mat-dialog-content>
  <form [formGroup]="requestForm">
    <!-- Type Toggle -->
    <div class="form-row" style="margin-bottom: 20px;">
      <mat-button-toggle-group formControlName="type" aria-label="Kayıt Tipi">
        <mat-button-toggle value="REQUISITION">Talep</mat-button-toggle>
        <!-- <mat-button-toggle value="EXPENSE" [disabled]="true">Masraf</mat-button-toggle> -->
      </mat-button-toggle-group>
    </div>
    
    <!-- Group Selections -->
    <div class="form-row">
      
      <!-- Readonly modda textbox göster -->
      <mat-form-field class="form-field" *ngIf="isReadOnly">
        <mat-label>Satınalma Üst Grubu</mat-label>
        <input matInput formControlName="pgCodeDesc" readonly>
      </mat-form-field>
      <!-- Insert modda dropdown göster -->
      <mat-form-field class="form-field" *ngIf="!isReadOnly">
        <mat-label>Satınalma Üst Grubu</mat-label>
        <mat-select formControlName="pgCode" 
                    (selectionChange)="onPgChange($event.value)"
                    panelClass="procurement-select-panel">
          <mat-option *ngFor="let group of pgGroups" [value]="group.value">
            {{group.value}} - {{group.description}}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="requestForm.get('pgCode')?.hasError('required')">
          Satınalma Üst Grubu Seçiniz
        </mat-error>
      </mat-form-field>

      <!-- Readonly modda textbox göster -->
      <mat-form-field class="form-field" *ngIf="isReadOnly">
        <mat-label>Satınalma Alt Grubu</mat-label>
        <input matInput formControlName="pgdCodeDesc" readonly>
      </mat-form-field>
      <!-- Insert modda dropdown göster -->
      <mat-form-field class="form-field" *ngIf="!isReadOnly">
        <mat-label>Satınalma Alt Grubu</mat-label>
        <mat-select formControlName="pgdCode" 
                    (selectionChange)="onPgdChange($event.value)"
                    panelClass="procurement-select-panel">
          <mat-option *ngFor="let group of pgdGroups" [value]="group.value">
            {{group.value}} - {{group.description}}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="requestForm.get('pgdCode')?.hasError('required')">
          Satınalma Alt Grubu Seçiniz
        </mat-error>
      </mat-form-field>

      <!-- Readonly modda textbox göster -->
      <mat-form-field class="form-field" *ngIf="isReadOnly">
        <mat-label>İş Kolu</mat-label>
        <input matInput formControlName="wgCodeDesc" readonly>
      </mat-form-field>
      <!-- Insert modda dropdown göster -->
      <mat-form-field class="form-field" *ngIf="!isReadOnly">
        <mat-label>İş Kolu</mat-label>
        <mat-select formControlName="wgCode"
                    panelClass="procurement-select-panel">
          <mat-option *ngFor="let group of wgGroups" [value]="group.value">
            {{group.value}} - {{group.description}}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="requestForm.get('wgCode')?.hasError('required')">
          İş Kolu Seçiniz
        </mat-error>
      </mat-form-field>
    </div>

    <!-- Satıcı (MASRAF için) / Satıcı Önerisi (TALEP için) -->
    <div class="form-row" *ngIf="recordType === 'EXPENSE'">
      <!-- MASRAF - Satıcı -->
      <!-- Edit mode - Satıcı Dropdown (her zaman göster) -->
      <mat-form-field class="form-field" *ngIf="!isReadOnly">
        <mat-label>Satıcı (3 karakter yazın)</mat-label>
        <input matInput 
               formControlName="vendorSearch"
               [matAutocomplete]="autoVendor"
               placeholder="Arama yapın...">
        <mat-autocomplete #autoVendor="matAutocomplete" 
                          [displayWith]="displayVendor"
                          (optionSelected)="onVendorSelect($event.option.value)">
          <mat-option *ngFor="let vendor of vendorList" [value]="vendor">
            {{displayVendor(vendor)}}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>

      <!-- Readonly mode - Satıcı (her zaman göster) -->
      <mat-form-field class="form-field" *ngIf="isReadOnly">
        <mat-label>Satıcı</mat-label>
        <input matInput [value]="displayVendor(selectedVendor)" readonly>
      </mat-form-field>

      <!-- Edit mode - Vergi No (Diğer seçiliyse) -->
      <mat-form-field class="form-field" *ngIf="!isReadOnly && showOtherVendorFields">
        <mat-label>Vergi No</mat-label>
        <input matInput formControlName="otherVendorTaxNumber"
               (blur)="validateTaxNumber(requestForm.get('otherVendorTaxNumber')?.value)">
        <mat-error *ngIf="taxNumberError">
          {{ taxNumberError }}
        </mat-error>
      </mat-form-field>

      <!-- Edit mode - Ad (Diğer seçiliyse) -->
      <mat-form-field class="form-field" *ngIf="!isReadOnly && showOtherVendorFields">
        <mat-label>Ad</mat-label>
        <input matInput formControlName="otherVendorName">
      </mat-form-field>

      <!-- Readonly mode - Vergi No (Diğer seçiliyse) -->
      <mat-form-field class="form-field" *ngIf="isReadOnly && showOtherVendorFields">
        <mat-label>Vergi No</mat-label>
        <input matInput [value]="requestForm.get('otherVendorTaxNumber')?.value" readonly>
      </mat-form-field>

      <!-- Readonly mode - Ad (Diğer seçiliyse) -->
      <mat-form-field class="form-field" *ngIf="isReadOnly && showOtherVendorFields">
        <mat-label>Ad</mat-label>
        <input matInput [value]="requestForm.get('otherVendorName')?.value" readonly>
      </mat-form-field>
    </div>
    
    <!-- TALEP - Satıcı Önerisi -->
    <div *ngIf="recordType === 'REQUISITION'">
      <!-- Satıcı tanımlı mı? sorusu -->
      <div class="form-row" *ngIf="!isReadOnly">
        <label class="form-label">Satıcı tanımlı mı?</label>
        <mat-radio-group formControlName="isVendorDefined">
          <mat-radio-button [value]="true">Evet</mat-radio-button>
          <mat-radio-button [value]="false">Hayır</mat-radio-button>
        </mat-radio-group>
      </div>
      
      <!-- Satıcı tanımlı - Vendor search -->
      <div class="form-row" *ngIf="!isReadOnly && requestForm.get('isVendorDefined')?.value === true">
        <mat-form-field class="form-field">
          <mat-label>Satıcı Önerisi (3 karakter yazın)</mat-label>
          <input matInput 
                 formControlName="vendorSearch"
                 [matAutocomplete]="autoVendorReq"
                 placeholder="Arama yapın..."
                 (keyup)="onVendorSearch($event)">
          <mat-autocomplete #autoVendorReq="matAutocomplete" 
                            [displayWith]="displayVendor"
                            (optionSelected)="onVendorSelect($event.option.value)">
            <mat-option *ngFor="let vendor of vendorList" [value]="vendor">
              {{vendor.name}} - {{vendor.taxNumber}}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>
      
      <!-- Satıcı tanımlı değil - Manual entry fields -->
      <div class="form-row" *ngIf="!isReadOnly && requestForm.get('isVendorDefined')?.value === false">
        <mat-form-field class="form-field">
          <mat-label>Firma Adı</mat-label>
          <input matInput formControlName="otherVendorName">
        </mat-form-field>
        
        <mat-form-field class="form-field">
          <mat-label>Telefon</mat-label>
          <input matInput formControlName="otherVendorPhone" appPhoneMask placeholder="0(5XX) XXX XX XX">
        </mat-form-field>
        
        <mat-form-field class="form-field">
          <mat-label>İlgili Kişi</mat-label>
          <input matInput formControlName="otherVendorRelatedPerson">
        </mat-form-field>
        
        <mat-form-field class="form-field">
          <mat-label>Adres Tarifi</mat-label>
          <textarea matInput formControlName="otherVendorAddress" rows="2"></textarea>
        </mat-form-field>
      </div>
      
      <!-- Readonly mode - Satıcı Önerisi -->
      <div class="form-row" *ngIf="isReadOnly">
        <mat-form-field class="form-field" *ngIf="requestForm.get('isVendorDefined')?.value === true">
          <mat-label>Satıcı Önerisi</mat-label>
          <input matInput [value]="displayVendor(selectedVendor)" readonly>
        </mat-form-field>
        
        <mat-form-field class="form-field" *ngIf="requestForm.get('isVendorDefined')?.value === false">
          <mat-label>Firma Adı</mat-label>
          <input matInput [value]="requestForm.get('otherVendorName')?.value" readonly>
        </mat-form-field>
        
        <mat-form-field class="form-field" *ngIf="requestForm.get('isVendorDefined')?.value === false">
          <mat-label>Telefon</mat-label>
          <input matInput [value]="requestForm.get('otherVendorPhone')?.value" readonly>
        </mat-form-field>
        
        <mat-form-field class="form-field" *ngIf="requestForm.get('isVendorDefined')?.value === false">
          <mat-label>İlgili Kişi</mat-label>
          <input matInput [value]="requestForm.get('otherVendorRelatedPerson')?.value" readonly>
        </mat-form-field>
        
        <mat-form-field class="form-field" *ngIf="requestForm.get('isVendorDefined')?.value === false">
          <mat-label>Adres Tarifi</mat-label>
          <textarea matInput [value]="requestForm.get('otherVendorAddress')?.value" readonly rows="2"></textarea>
        </mat-form-field>
      </div>
    </div>

    <!-- Talep Başlığı (AI destekli - ne neden nereye) -->
    <div class="form-row">
      <mat-form-field class="form-field">
        <mat-label *ngIf="recordType === 'REQUISITION'">Talep Başlığı</mat-label>
        <mat-label *ngIf="recordType === 'EXPENSE'">Masraf Başlığı</mat-label>
        <input matInput formControlName="requestHeader" placeholder="Ne, neden, nereye...">
      </mat-form-field>
    </div>
    <div class="validation-warning" *ngIf="headerValidationSuggestion">
      {{ headerValidationSuggestion }}
    </div>
    
    <!-- Talep Açıklaması -->
    <div class="form-row">
      <mat-form-field class="form-field">
        <mat-label *ngIf="recordType === 'REQUISITION'">Talep Açıklaması</mat-label>
        <mat-label *ngIf="recordType === 'EXPENSE'">Masraf Açıklaması</mat-label>
        <input matInput formControlName="explanation">
      </mat-form-field>
    </div>

    <!-- Ödeme Tipi ve Kredi Kartı (sadece MASRAF için) -->
    <div class="form-row" *ngIf="recordType === 'EXPENSE'">
      <mat-form-field class="form-field" *ngIf="!isReadOnly">
        <mat-label>Ödeme Tipi</mat-label>
        <mat-select formControlName="paymentType" panelClass="procurement-select-panel">
          <mat-option value="">Seçiniz</mat-option>
          <mat-option *ngFor="let pt of paymentTypeList" [value]="pt.lookupValue">
            {{pt.lookupValue}} - {{pt.description}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field class="form-field" *ngIf="isReadOnly">
        <mat-label>Ödeme Tipi</mat-label>
        <input matInput [value]="getPaymentTypeDisplay()" readonly>
      </mat-form-field>

      <mat-form-field class="form-field" *ngIf="isCreditCardSelected() && !isReadOnly">
        <mat-label>Kredi Kartı</mat-label>
        <mat-select formControlName="selectedCard" panelClass="procurement-select-panel">
          <mat-option value="">Seçiniz</mat-option>
          <mat-option *ngFor="let card of creditCardList" [value]="card.lookupValue">
            {{card.lookupValue}} - {{card.description}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field class="form-field" *ngIf="isCreditCardSelected() && isReadOnly">
        <mat-label>Kredi Kartı</mat-label>
        <input matInput [value]="getSelectedCardDisplay()" readonly>
      </mat-form-field>
    </div>

    <!-- Fatura Tarihi (sadece MASRAF için) -->
    <div class="form-row" *ngIf="recordType === 'EXPENSE'">
      <mat-form-field class="form-field">
        <mat-label>Fatura Tarihi *</mat-label>
        <input matInput [matDatepicker]="invoicePicker" formControlName="invoiceDate" [readonly]="isReadOnly">
        <mat-datepicker-toggle matSuffix [for]="invoicePicker" *ngIf="!isReadOnly"></mat-datepicker-toggle>
        <mat-datepicker #invoicePicker></mat-datepicker>
        <mat-error *ngIf="requestForm.get('invoiceDate')?.hasError('required')">
          Fatura tarihi zorunludur
        </mat-error>
        <mat-error *ngIf="requestForm.get('invoiceDate')?.hasError('futureDate')">
          Gelecek tarih seçilemez
        </mat-error>
        <mat-error *ngIf="requestForm.get('invoiceDate')?.hasError('exceeds30BusinessDays')">
          Son 30 iş günü içinde bir tarih seçiniz
        </mat-error>
      </mat-form-field>
    </div>

    <!-- Add Row Button -->
    <div class="add-row-section" *ngIf="!isReadOnly">
      <button mat-raised-button color="accent" type="button" (click)="addDetail()">
        <mat-icon>add</mat-icon>
        Satır Ekle
      </button>
    </div>

    <!-- Details Table -->
    <div class="details-table" formArrayName="details">
      <table mat-table [dataSource]="dataSource" class="mat-elevation-z2">

        <!-- Item Code / Masraf Kodu -->
        <ng-container matColumnDef="itemCode">
          <th mat-header-cell *matHeaderCellDef>Masraf Kodu</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
            <mat-form-field class="table-field" *ngIf="!isReadOnly">
              <mat-select formControlName="itemId" 
                          [disabled]="procurementItems.length === 0"
                          (selectionChange)="onItemSelect($event.value, i)"
                          panelClass="procurement-select-panel">
                <mat-option *ngFor="let item of procurementItems" [value]="item.id">
                  {{item.code}} - {{item.name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field class="table-field" *ngIf="isReadOnly">
              <input matInput formControlName="itemName" readonly>
            </mat-form-field>
          </td>
        </ng-container>

        <!-- Item Description / Ürün Hizmet Açıklaması -->
        <ng-container matColumnDef="itemDesc">
          <th mat-header-cell *matHeaderCellDef>Ürün/Hizmet Açıklaması</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
            <mat-form-field class="table-field">
              <input matInput formControlName="itemDesc">
            </mat-form-field>
          </td>
        </ng-container>

        <!-- Product/Service Link / Ürün/Hizmet Linki (TALEP için) -->
        <ng-container matColumnDef="productLink">
          <th mat-header-cell *matHeaderCellDef>Ürün/Hizmet Linki</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
            <mat-form-field class="table-field" *ngIf="!isReadOnly">
              <input matInput formControlName="productLink" placeholder="https://...">
            </mat-form-field>
            <div *ngIf="isReadOnly">
              <a *ngIf="row.get('productLink')?.value" 
                 [href]="row.get('productLink')?.value" 
                 target="_blank" 
                 rel="noopener noreferrer"
                 style="color: #1976d2; text-decoration: underline; cursor: pointer; word-break: break-all;">
                {{ row.get('productLink')?.value ? (row.get('productLink')?.value | slice:0:20) + (row.get('productLink')?.value.length > 20 ? '...' : '') : '' }}
              </a>
              <span *ngIf="!row.get('productLink')?.value">-</span>
            </div>
          </td>
        </ng-container>

        <!-- Brand -->
        <ng-container matColumnDef="brand">
          <th mat-header-cell *matHeaderCellDef>Marka</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
            <mat-form-field class="table-field">
              <input matInput formControlName="brandDesc">
            </mat-form-field>
          </td>
        </ng-container>

        <!-- Quantity -->
        <ng-container matColumnDef="quantity">
          <th mat-header-cell *matHeaderCellDef>Miktar</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
            <div class="quantity-with-unit">
              <mat-form-field class="table-field-small">
                <input matInput type="number" formControlName="quantity" min="1" step="1">
              </mat-form-field>
              <mat-form-field class="table-field-unit" *ngIf="!isReadOnly">
                <mat-select formControlName="uomDesc" panelClass="unit-type-panel">
                  <mat-option *ngFor="let ut of unitTypeList" [value]="ut.lookupValue">
                    {{ut.lookupValue}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <span class="base-unit-suffix" *ngIf="isReadOnly">{{ row.get('uomDesc')?.value }}</span>
            </div>
          </td>
        </ng-container>

        <!-- Birim Fiyat (sadece MASRAF için - KDV'den önce) -->
        <ng-container matColumnDef="unitPrice">
          <th mat-header-cell *matHeaderCellDef>Birim Fiyat</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
            <mat-form-field class="table-field-small">
              <input matInput type="number" formControlName="unitPrice" min="0" step="0.01">
            </mat-form-field>
          </td>
        </ng-container>

        <!-- Unit (Departman) -->
        <ng-container matColumnDef="unit">
          <th mat-header-cell *matHeaderCellDef>Departman</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
            <mat-form-field class="table-field" *ngIf="!isReadOnly">
              <mat-select formControlName="departmentId">
                <mat-option *ngFor="let dept of departmentList" [value]="dept.id">
                  {{dept.lookupValue}} - {{dept.description}}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field class="table-field" *ngIf="isReadOnly">
              <input matInput formControlName="departmentDesc" readonly>
            </mat-form-field>
          </td>
        </ng-container>

        <!-- Location/Project -->
        <ng-container matColumnDef="location">
          <th mat-header-cell *matHeaderCellDef>Lokasyon/Proje</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
            <mat-form-field class="table-field" *ngIf="!isReadOnly">
              <mat-select formControlName="projectCode" (selectionChange)="onProjectChange($event.value, i)">
                <mat-option value="TENANT">Kiracı</mat-option>
                <mat-option *ngFor="let project of projectList" [value]="project.lookupValue">
                  {{formatProjectTenantDescription(project.description)}}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field class="table-field" *ngIf="isReadOnly">
              <input matInput formControlName="projectDesc" readonly>
            </mat-form-field>
          </td>
        </ng-container>

        <!-- Tenant/Kiracı (sadece Kiracı seçiliyse) -->
        <ng-container matColumnDef="tenant">
          <th mat-header-cell *matHeaderCellDef>
            <span *ngIf="isAnyTenantVisible()">Kiracı</span>
          </th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
            <mat-form-field class="table-field" *ngIf="isTenantVisible(i) && !isReadOnly">
              <mat-select formControlName="tenantCode">
                <mat-option *ngFor="let tenant of tenantList" [value]="tenant.lookupValue">
                  {{formatProjectTenantDescription(tenant.description)}}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field class="table-field" *ngIf="isTenantVisible(i) && isReadOnly">
              <input matInput formControlName="tenantDesc" readonly>
            </mat-form-field>
          </td>
        </ng-container>

        <!-- VAT Rate (Masraf için) -->
        <ng-container matColumnDef="vatRate">
          <th mat-header-cell *matHeaderCellDef>KDV %</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
            <mat-form-field class="table-field-small">
              <mat-select formControlName="vatRate" (selectionChange)="calculateAmountAndVat(details.at(i))">
                <mat-option *ngFor="let rate of vatRates" [value]="rate">
                  %{{rate}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </td>
        </ng-container>

        <!-- Amount (Masraf için - unitPrice * quantity ile hesaplanan) -->
        <ng-container matColumnDef="amount">
          <th mat-header-cell *matHeaderCellDef>Tutar</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
            <mat-form-field class="table-field-small">
              <input matInput type="number" formControlName="amount" min="0" step="0.01" readonly>
            </mat-form-field>
          </td>
        </ng-container>

        <!-- VAT Amount (Masraf için - otomatik hesaplanan) -->
        <ng-container matColumnDef="vatAmount">
          <th mat-header-cell *matHeaderCellDef>KDV Tutarı</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
            <mat-form-field class="table-field-small">
              <input matInput type="number" formControlName="vatAmount" min="0" step="0.01" readonly>
            </mat-form-field>
          </td>
        </ng-container>

        <!-- Actions -->
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>İşlemler</th>
          <td mat-cell *matCellDef="let row; let i = index">
            <button mat-icon-button matTooltip="Sil" type="button" class="iconbutton action-delete-button"
              (click)="removeDetail(i)" *ngIf="!isReadOnly">
              <mat-icon aria-label="delete">delete_forever</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
      
      <!-- Toplam Satırı (Sadece Masraf için) -->
      <div *ngIf="recordType === 'EXPENSE'" class="total-row">
        <strong>Toplam (KDV Dahil):</strong> {{getTotalAmount() | number:'1.2-2'}} TRY
      </div>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">{{isReadOnly ? 'Kapat' : 'İptal'}}</button>
  
  <!-- Sadece readonly modda ve showApproveReject true ise onay/red butonları göster -->
  <button mat-raised-button color="warn" (click)="onReject()" *ngIf="isReadOnly && showApproveReject">
    <mat-icon>highlight_off</mat-icon>
    Reddet
  </button>
  <button mat-raised-button color="primary" (click)="onApprove()" *ngIf="isReadOnly && showApproveReject">
    <mat-icon>check_circle</mat-icon>
    Onayla
  </button>
  
  <!-- Insert modunda sadece kaydet butonu -->
  <button mat-raised-button color="primary" (click)="onSave()" [disabled]="!requestForm.valid" *ngIf="!isReadOnly">
    Kaydet
  </button>
</mat-dialog-actions>